<template>
  <div class="apps-page">
    <!-- 商户头部 -->
    <div class="merchant-header">
      <div class="merchant-logo">
        <img v-if="merchantLogo" :src="merchantLogo" alt="logo" />
        <div v-else class="merchant-logo-placeholder">
          <span>{{ merchantName.charAt(0) }}</span>
        </div>
      </div>
      <div class="merchant-name">{{ merchantName }}</div>
    </div>

    <!-- 点评打卡 -->
    <div class="section">
      <div class="section-title">
        <span class="title-text">点评打卡</span>
      </div>
      <div class="card-box">
        <div class="app-grid">
          <div
            v-for="app in reviewApps"
            :key="app.key"
            class="app-card"
            :style="{ background: app.bgGradient }"
            @click="openApp(app)"
          >
            <div class="app-card-name">{{ app.name }}</div>
            <div class="app-logo" :style="{ background: app.logoBg, color: app.logoColor }">
              <span class="app-logo-text">{{ app.logoText }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 商家团购 -->
    <div class="section">
      <div class="section-title">
        <span class="title-text">商家团购</span>
      </div>
      <div class="card-box">
        <div class="app-grid-sm">
          <div
            v-for="app in groupApps"
            :key="app.key"
            class="app-card-sm"
            @click="openApp(app)"
          >
            <div class="app-logo-sm" :style="{ background: app.logoBg, color: app.logoColor }">
              <span class="app-logo-text">{{ app.logoText }}</span>
            </div>
            <div class="app-card-name-sm">{{ app.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 关注账号 -->
    <div class="section">
      <div class="section-title">
        <span class="title-text">关注账号</span>
      </div>
      <div class="card-box">
        <div class="app-grid-sm">
          <div
            v-for="app in followApps"
            :key="app.key"
            class="app-card-sm"
            @click="openApp(app)"
          >
            <div class="app-logo-sm" :style="{ background: app.logoBg, color: app.logoColor }">
              <span class="app-logo-text">{{ app.logoText }}</span>
            </div>
            <div class="app-card-name-sm">{{ app.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部占位，避免被浏览器工具栏遮挡 -->
    <div class="bottom-placeholder"></div>
  </div>
</template>

<script>
/**
 * 商家应用聚合页面
 * 点击对应的 app 会尝试通过 URL Scheme 唤起手机上已安装的 App。
 * 注意：在微信/QQ 等内置浏览器中，多数 scheme 会被拦截，建议使用系统浏览器打开。
 */
export default {
  name: 'Apps',
  data() {
    return {
      merchantName: '和空间咖啡馆',
      merchantLogo: '',
      reviewApps: [
        {
          key: 'xhs',
          name: '小红书',
          logoText: '小红书',
          logoBg: '#ff2442',
          logoColor: '#ffffff',
          bgGradient: 'linear-gradient(135deg, #fff0f2 0%, #ffe4e7 100%)',
          scheme: 'xhsdiscover://home',
          androidPackage: 'com.xingin.xhs',
          fallback: 'https://www.xiaohongshu.com/'
        },
        {
          key: 'dianping',
          name: '大众点评',
          logoText: '大',
          logoBg: '#ff6633',
          logoColor: '#ffffff',
          bgGradient: 'linear-gradient(135deg, #fff1ea 0%, #ffe1d0 100%)',
          scheme: 'dianping://home',
          androidPackage: 'com.dianping.v1',
          fallback: 'https://m.dianping.com/'
        },
        {
          key: 'douyin',
          name: '抖音点评',
          logoText: '♪',
          logoBg: '#000000',
          logoColor: '#ffffff',
          bgGradient: 'linear-gradient(135deg, #efeaff 0%, #e0d8ff 100%)',
          scheme: 'snssdk1128://',
          androidPackage: 'com.ss.android.ugc.aweme',
          fallback: 'https://www.douyin.com/'
        },
        {
          key: 'meituan',
          name: '美团点评',
          logoText: '美团',
          logoBg: '#ffd100',
          logoColor: '#222222',
          bgGradient: 'linear-gradient(135deg, #fff8dc 0%, #fff1b8 100%)',
          scheme: 'imeituan://www.meituan.com/',
          androidPackage: 'com.sankuai.meituan',
          fallback: 'https://i.meituan.com/'
        },
        {
          key: 'amap',
          name: '高德点评',
          logoText: '➤',
          logoBg: 'linear-gradient(135deg, #8ed8ff 0%, #4e9bff 100%)',
          logoColor: '#ffffff',
          bgGradient: 'linear-gradient(135deg, #eaf4ff 0%, #d7e9ff 100%)',
          scheme: 'iosamap://',
          androidScheme: 'androidamap://',
          androidPackage: 'com.autonavi.minimap',
          fallback: 'https://www.amap.com/'
        }
      ],
      groupApps: [
        {
          key: 'meituan-group',
          name: '美团团购',
          logoText: '美团',
          logoBg: '#ffd100',
          logoColor: '#222222',
          // iOS：短链会触发美团 Universal Link 直接打开 App；无 App 时回落到 H5
          iosDirectUrl: 'http://dpurl.cn/RKFCjsxz',
          scheme: 'imeituan://www.meituan.com/',
          androidPackage: 'com.sankuai.meituan',
          fallback: 'http://dpurl.cn/RKFCjsxz'
        },
        {
          key: 'dianping-group',
          name: '大众点评团购',
          logoText: '大',
          logoBg: '#ff6633',
          logoColor: '#ffffff',
          scheme: 'dianping://home',
          androidPackage: 'com.dianping.v1',
          fallback: 'https://m.dianping.com/'
        },
        {
          key: 'douyin-group',
          name: '抖音团购',
          logoText: '♪',
          logoBg: '#000000',
          logoColor: '#ffffff',
          scheme: 'snssdk1128://lifeservice',
          androidPackage: 'com.ss.android.ugc.aweme',
          fallback: 'https://life.douyin.com/'
        }
      ],
      followApps: [
        {
          key: 'wechat-mp',
          name: '微信公众号',
          logoText: '微',
          logoBg: '#07c160',
          logoColor: '#ffffff',
          scheme: 'weixin://',
          androidPackage: 'com.tencent.mm',
          fallback: 'weixin://'
        },
        {
          key: 'douyin-follow',
          name: '抖音账号',
          logoText: '♪',
          logoBg: '#000000',
          logoColor: '#ffffff',
          scheme: 'snssdk1128://user/profile',
          androidPackage: 'com.ss.android.ugc.aweme',
          fallback: 'https://www.douyin.com/'
        },
        {
          key: 'xhs-follow',
          name: '小红书账号',
          logoText: '小红书',
          logoBg: '#ff2442',
          logoColor: '#ffffff',
          scheme: 'xhsdiscover://user',
          androidPackage: 'com.xingin.xhs',
          fallback: 'https://www.xiaohongshu.com/'
        }
      ]
    };
  },
  created() {
    const q = (this.$route && this.$route.query) || {};
    if (q.merchantName) {
      this.merchantName = decodeURIComponent(q.merchantName);
    }
    if (q.merchantLogo) {
      this.merchantLogo = decodeURIComponent(q.merchantLogo);
    }
  },
  methods: {
    isAndroid() {
      return /android/i.test(navigator.userAgent || '');
    },
    isIOS() {
      return /iphone|ipad|ipod/i.test(navigator.userAgent || '');
    },
    isWeChat() {
      return /MicroMessenger/i.test(navigator.userAgent || '');
    },
    /**
     * 构造 Android Chrome Intent 链接
     * 格式参考：intent://host/path#Intent;scheme=xxx;package=xxx;S.browser_fallback_url=xxx;end
     * 新版 Chrome 已不再允许通过 iframe 直接跳 scheme，改用 Intent 可大幅提升成功率
     */
    buildIntentUrl(app) {
      const scheme = app.androidScheme || (app.scheme || '').split('://')[0];
      const path = (app.scheme || '').split('://')[1] || '';
      const pkg = app.androidPackage || '';
      const fb = encodeURIComponent(app.fallback || '');
      let url = 'intent://' + path + '#Intent;scheme=' + scheme + ';';
      if (pkg) url += 'package=' + pkg + ';';
      if (fb) url += 'S.browser_fallback_url=' + fb + ';';
      url += 'end';
      return url;
    },
    /**
     * 唤起手机上对应的 App
     * 思路：
     *   1. 立即触发 URL Scheme / Universal Link / Chrome Intent
     *   2. 监听 visibilitychange / pagehide，页面一旦被系统切到后台，说明唤起成功，清除兜底定时器
     *   3. 3 秒内没切走，判定为未安装，跳到 H5 兜底
     */
    openApp(app) {
      if (this.isWeChat()) {
        alert('微信内不支持直接唤起外部 App，请点击右上角 · · · 选择"在浏览器中打开"');
        return;
      }

      const fallback = app.fallback || '';
      const isIOS = this.isIOS();
      const isAndroid = this.isAndroid();

      // 标记是否已成功唤起
      let launched = false;
      let fallbackTimer = null;

      const cleanup = () => {
        if (fallbackTimer) {
          clearTimeout(fallbackTimer);
          fallbackTimer = null;
        }
        document.removeEventListener('visibilitychange', onVisibilityChange);
        window.removeEventListener('pagehide', onPageHide);
        window.removeEventListener('blur', onBlur);
      };

      const onVisibilityChange = () => {
        if (document.hidden) {
          launched = true;
          cleanup();
        }
      };
      const onPageHide = () => {
        launched = true;
        cleanup();
      };
      // blur 可靠性差（iOS 有时切 tab 也会触发），只作为辅助信号
      const onBlur = () => {
        launched = true;
      };

      document.addEventListener('visibilitychange', onVisibilityChange);
      window.addEventListener('pagehide', onPageHide);
      window.addEventListener('blur', onBlur);

      // 触发唤起
      try {
        if (isIOS) {
          // iOS：优先用 Universal Link（iosDirectUrl），其次用 URL Scheme
          const target = app.iosDirectUrl || app.scheme;
          if (target) {
            window.location.href = target;
          }
        } else if (isAndroid) {
          // Android：用 Chrome Intent，系统会自动处理：装了就打开 App，没装就走 S.browser_fallback_url
          window.location.href = this.buildIntentUrl(app);
        } else {
          // 桌面或其他环境：直接跳 H5
          if (fallback) window.location.href = fallback;
          cleanup();
          return;
        }
      } catch (e) {
        // ignore
      }

      // 3 秒后仍未切换走，判定为未安装，跳网页兜底
      // 注意：Android Intent 已经由系统走了 fallback，这里主要给 iOS 用
      fallbackTimer = setTimeout(() => {
        cleanup();
        if (!launched && !document.hidden && fallback) {
          // Android 下 Intent 已处理兜底，无需重复
          if (!isAndroid) {
            window.location.href = fallback;
          }
        }
      }, 3000);
    }
  }
};
</script>

<style lang="css" scoped>
.apps-page {
  min-height: 100vh;
  background: #f5f6f8;
  padding: 0.32rem 0.32rem 1rem;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #111;
}

.merchant-header {
  display: flex;
  align-items: center;
  padding: 0.3rem 0.1rem 0.4rem;
}

.merchant-logo {
  width: 0.88rem;
  height: 0.88rem;
  border-radius: 0.12rem;
  overflow: hidden;
  background: #e9ebef;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.08);
}

.merchant-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.merchant-logo-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.46rem;
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(135deg, #6a7a95 0%, #3c4d6d 100%);
}

.merchant-name {
  margin-left: 0.24rem;
  font-size: 0.38rem;
  font-weight: 600;
  color: #111;
}

.section {
  margin-top: 0.3rem;
}

.section-title {
  padding: 0 0.08rem 0.22rem;
}

.title-text {
  position: relative;
  display: inline-block;
  font-size: 0.34rem;
  font-weight: 700;
  color: #111;
  padding-bottom: 0.06rem;
  background-image: linear-gradient(transparent 65%, rgba(255, 62, 73, 0.55) 65%);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.card-box {
  background: #ffffff;
  border-radius: 0.28rem;
  padding: 0.32rem 0.28rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.04);
}

.app-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.24rem;
}

.app-card {
  position: relative;
  border-radius: 0.2rem;
  padding: 0.26rem 0.24rem;
  height: 1.6rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.15s ease;
}

.app-card:active {
  transform: scale(0.97);
}

.app-card-name {
  font-size: 0.3rem;
  font-weight: 600;
  color: #222;
}

.app-logo {
  align-self: flex-end;
  width: 0.94rem;
  height: 0.94rem;
  border-radius: 0.18rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.04rem 0.12rem rgba(0, 0, 0, 0.1);
}

.app-logo-text {
  font-size: 0.24rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  padding: 0 0.04rem;
  word-break: keep-all;
}

.app-grid-sm {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.2rem;
}

.app-card-sm {
  background: #f7f8fb;
  border-radius: 0.2rem;
  padding: 0.24rem 0.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.15s ease;
}

.app-card-sm:active {
  transform: scale(0.96);
}

.app-logo-sm {
  width: 0.92rem;
  height: 0.92rem;
  border-radius: 0.18rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.04rem 0.12rem rgba(0, 0, 0, 0.08);
  margin-bottom: 0.14rem;
}

.app-card-name-sm {
  font-size: 0.26rem;
  color: #333;
}

.bottom-placeholder {
  height: 0.8rem;
}
</style>
